<template>
  <section class="viewsrhwxIntoCodecomponents_pathList">
    <div class="list">
      <div class="item" @click="into1()">
        <div>
          <span><img src="../../assets/img/into3.png" alt=""/></span>
          <span>司机报到</span>
        </div>
        <div class="r">
          <span>进入</span>
          <van-icon name="arrow" />
        </div>
      </div>
      <van-divider class="m0"></van-divider>
      <div class="item" @click="into2()">
        <div>
          <span><img src="../../assets/img/into2.png" alt=""/></span>
          <span>司机确认篷布防护</span>
        </div>
        <div class="r">
          <span>进入</span>
          <van-icon name="arrow" />
        </div>
      </div>
      <van-divider class="m0"></van-divider>
      <div class="item" @click="into3()">
        <div>
          <span><img src="../../assets/img/into1.png" alt=""/></span>
          <span>关注红塔公众号</span>
        </div>
        <div class="r">
          <span>进入</span>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: [""],

  data() {
    return {};
  },

  computed: {},

  watch: {},

  components: {},

  mixins: [],

  created() {},

  mounted() {},

  methods: {
    into1() {
      this.$emit("into1");
    },
    into2() {
      this.$emit("into2");
    },
    into3() {
      this.$router.push({
        path: "/rhwxIntoCodeFollowCode",
        query: {
          map_type: this.$route.query.map_type,
          com_id: this.$route.query.com_id,
          sub_com_id: this.$route.query.sub_com_id
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.viewsrhwxIntoCodecomponents_pathList {
  .list {
    background: #ffffff;
    box-shadow: 0 2px 12px 0 rgba(100, 101, 102, 0.2);
    border-radius: 18px;
    padding: 0 16px;
    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.9);
      height: 70px;
      div {
        display: flex;
        align-items: center;
        img {
          width: 22px;
          margin-right: 8px;
        }
      }
      .r {
        font-size: 12px;
        color: #666666;
      }
    }
    .m0 {
      margin: 0;
    }
  }
}
</style>
<style lang="less">
.viewsrhwxIntoCodecomponents_pathList {
}
</style>
